module.exports = __webpack_public_path__ + "img/@img_m.77726a40.jpg";